import * as ActionTypes from '../actions/profile'
import { profile as profileModel } from '$models/profile'

const initialState = {
  successCover: false,
  errorAvatar: false,
  errorCover: false,
  successAvatar: false,
  successUpdate: false,
  error: {}
}

export const profile = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.UPLOAD_COVER_SUCCESS: {
      const profile = profileModel(action.response)

      return {
        ...state,
        ...profile,
        successCover: true
      }
    }

    case ActionTypes.UPLOAD_COVER_FAILURE: {
      return {
        ...state,
        error: {
          message: action.error.cover[0],
          level: 'alert'
        },
        successCover: false
      }
    }

    case ActionTypes.UPLOAD_COVER_REQUEST: {
      return {
        ...state,
        successCover: false
      }
    }

    case ActionTypes.UPLOAD_AVATAR_SUCCESS: {
      const profile = profileModel(action.response)

      return {
        ...state,
        ...profile,
        successAvatar: true
      }
    }

    case ActionTypes.UPLOAD_AVATAR_FAILURE: {
      return {
        ...state,
        successAvatar: false
      }
    }

    case ActionTypes.UPLOAD_AVATAR_REQUEST: {
      return {
        ...state,
        successAvatar: false
      }
    }

    case ActionTypes.UPLOAD_USER_SUCCESS: {
      return {
        ...state,
        successUpdate: true
      }
    }

    case ActionTypes.UPLOAD_USER_FAILURE: {
      return {
        ...state,
        successUpdate: false
      }
    }

    default:
      return state
  }
}
